import moment from 'moment';
import { TAccordionMoreInfoItem, TAccordionMoreInfoItemBaseValues } from '../../model/accordion-table.types';

export const TICKET_LIST_HELPER = {
  timeInMinsToDisplayString(timeInMins: number | undefined): TAccordionMoreInfoItem['values'] {
    if (timeInMins === undefined) return [{ displayName: '--' }];
    else if (timeInMins === 0) return [{ displayName: '0' }, { displayName: 'common.mins' }];
    else {
      const days = Math.floor(timeInMins / (24 * 60));
      const hours = Math.floor(timeInMins / 60) % 24;
      const mins = timeInMins % 60;
      let retVal: TAccordionMoreInfoItemBaseValues[] = [];
      if (days > 0) retVal = retVal.concat([{ displayName: days.toString() }, { displayName: 'common.days' }]);
      if (hours > 0) retVal = retVal.concat([{ displayName: hours.toString() }, { displayName: 'common.hrs' }]);
      if (mins > 0) retVal = retVal.concat([{ displayName: mins.toString() }, { displayName: 'common.mins' }]);
      return retVal;
    }
  },

  formatTimeStamp(timeInMins: number | undefined) {
    return timeInMins === undefined ? '--' : moment(timeInMins).format('D MMM YYYY, h:mm a');
  },

  mapToValuesList(stringList: string[] | number[]) {
    return stringList.map((str) => {
      return {
        displayName: str,
      };
    });
  },

  getLocation(locationDisplayName: string[], workstationName?: string): TAccordionMoreInfoItem['values'] {
    let retVal: TAccordionMoreInfoItem['values'] = locationDisplayName.map((x) => ({ displayName: x }));
    if (workstationName) {
      retVal = retVal.concat([
        { displayName: ', ' },
        { displayName: 'line_setup.WorkstationName' },
        { displayName: ': ' },
        { displayName: workstationName },
      ]);
    }
    return retVal;
  },
};
